import React, {Component} from 'react';

import WizardNavigator from './WizardNavigator'

class NavigatorAdvanced extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  setStateGlobal = (state) => {
    const {setParentState} = this.props;
    setParentState(state);
  }
  setStateGlobalSteps = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }
  render() {

    const {
      leftFirstDivClassName,
      leftSecondDivClassName,
      leftTextSecondDivClassName,
      leftLabelClassNameTittle,
      leftLabelTextTittle,
      leftLabelClassNameDescription,
      leftLabelDescription,
      centerFirstDivClassName,
      centerSecondDivClassName,
      centerTextSecondDivClassName,
      centerLabelClassNameTittle,
      centerLabelTextTittle,
      centerLabelClassNameDescription,
      centerLabelDescription,
      rightFirstDivClassName,
      rightSecondDivClassName,
      rightTextSecondDivClassName,
      rightLabelClassNameTittle,
      rightLabelTextTittle,
      rightLabelClassNameDescription,
      rightLabelDescription,
      leftBarClassName,
      rightBarClassName,
      parentState
    } = this.props;

    return (<nav className='nav'>
      <div className='nav-center'>
        <WizardNavigator firstDivClassName={leftFirstDivClassName} secondDivClassName={leftSecondDivClassName} textSecondDivClassName={leftTextSecondDivClassName} labelClassNameTittle={leftLabelClassNameTittle} textLabelTittle={leftLabelTextTittle} labelClassNameDescription={leftLabelClassNameDescription} textLabelDescription={leftLabelDescription} parentState={parentState} setParentStateSteps={this.setStateGlobalSteps} pageToRender={0}/>
        <div className="wizard-separator w-s1-fix">
          <div className={leftBarClassName}></div>
        </div>
        <WizardNavigator firstDivClassName={centerFirstDivClassName} secondDivClassName={centerSecondDivClassName} textSecondDivClassName={centerTextSecondDivClassName} labelClassNameTittle={centerLabelClassNameTittle} textLabelTittle={centerLabelTextTittle} labelClassNameDescription={centerLabelClassNameDescription} textLabelDescription={centerLabelDescription} parentState={parentState} setParentStateSteps={this.setStateGlobalSteps} pageToRender={1}/>
        <div className="wizard-separator w-s2-fix">
          <div className={rightBarClassName}></div>
        </div>
        <WizardNavigator firstDivClassName={rightFirstDivClassName} secondDivClassName={rightSecondDivClassName} textSecondDivClassName={rightTextSecondDivClassName} labelClassNameTittle={rightLabelClassNameTittle} textLabelTittle={rightLabelTextTittle} labelClassNameDescription={rightLabelClassNameDescription} textLabelDescription={rightLabelDescription} parentState={parentState} setParentStateSteps={this.setStateGlobalSteps} pageToRender={2}/>
      </div>
    </nav>);
  }
}

export default NavigatorAdvanced;
